const FeesStructure = () => {
    return (
        <div id="fees" className="vision-card">
            <h3>FEES STRUCTURE</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th>CLASS</th>
                            <th>ADMISSION FEE (IN RUPEES)</th>
                            <th>YEARL Y DEVELOPMENT CHARGES (IN RUPEES)</th>
                            <th>TUITION FEE (IN RUPEES)</th>
                            <th>YEARLY OTHER CHARGES (in Rupees)</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>PRIMARY 1-5</td>
                            <td>3500 X 1</td>
                            <td>1350 X 12</td>
                            <td>4400 X 1</td>
                            <td>568 X 12</td>
                        </tr>

                        <tr>
                            <td>MIDDLE</td>
                            <td>1000</td>
                            <td>3500</td>
                            <td>2000</td>
                            <td>2900</td>
                        </tr>

                        <tr>
                            <td>SECONDARY</td>
                            <td>1000</td>
                            <td>3500</td>
                            <td>2500</td>
                            <td>3700</td>
                        </tr>

                        <tr>
                            <td>SENIOR SECONDARY</td>
                            <td>1000</td>
                            <td>3500</td>
                            <td>3000</td>
                            <td>4100</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FeesStructure;